import type { FaireProductEntity } from "../../entity_types/product";

export const p_ux3td9cca9: FaireProductEntity = {
  token: "p_ux3td9cca9",
  type: "product",
  name: "Smoked Cherry– HI-FI Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/26575e85a3b1d4f02233b3289fcb19fabc0c97bb27cc3a3aca32e5242e135fae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f13a7fe9fb2a451310c7b1afa33751319032b2cdf775d8eee4517ee4a2541cd7.jpeg",
    "https://cdn.faire.com/fastly/80a7572d02875d41d07ae7f86645849b0dce8cc8c88fdabcc3607f12fb0c82a8.jpeg",
    "https://cdn.faire.com/fastly/35be466f5d0df869894a305848d54b1e42427ea04aeeb76752a061b1e1fc752d.jpeg",
    "https://cdn.faire.com/fastly/7718e1855738ed8bb41019ee25618fc6d9020643ed580b0fe682b248ca590300.jpeg",
    "https://cdn.faire.com/fastly/4360c47c9a100dc14def27d13cb1bb6b47f16e2df06b90b3d1ae16730de62f71.jpeg",
  ],
  priceDollars: 21.5,
  description:
    "Plush velvet and smooth banquettes in a dimly lit cocktail lounge. Musky, earthy, and soft with a velvety floral undertone.  Haitian vetiver, velvet iris, patchouli leaf, and beetroot.\n\nPRODUCT INFORMATION: \n\nOur 13 oz Double Wick Hi-Fi Candles are hand-poured into premium cocoa brown vessels with a vermilion debossed label, and packaged in a premium paper gift box.\n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for up to 60 hours.",
  tags: [],
  msrpDollars: 43.98,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T21:36:03.710Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
